export const getBudgetColumns = (): string[] => [
  "new_521_01",
  "new_521_02",
  "new_521_03",
  "new_521_04",
  "new_521_05",
  "new_521_06",
  "new_521_07",
  "new_521_08",
  "new_521_09",
  "new_521_10",
  "new_521_11",
  "new_521_12",
  "new_524_01",
  "new_524_02",
  "new_524_03",
  "new_524_04",
  "new_524_05",
  "new_524_06",
  "new_524_07",
  "new_524_08",
  "new_524_09",
  "new_524_10",
  "new_524_11",
  "new_524_12",
  "new_525_01",
  "new_525_02",
  "new_525_03",
  "new_525_04",
  "new_525_05",
  "new_525_06",
  "new_525_07",
  "new_525_08",
  "new_525_09",
  "new_525_10",
  "new_525_11",
  "new_525_12",
  "new_5271_01",
  "new_5271_02",
  "new_5271_03",
  "new_5271_04",
  "new_5271_05",
  "new_5271_06",
  "new_5271_07",
  "new_5271_08",
  "new_5271_09",
  "new_5271_10",
  "new_5271_11",
  "new_5271_12",
  "new_5274_01",
  "new_5274_02",
  "new_5274_03",
  "new_5274_04",
  "new_5274_05",
  "new_5274_06",
  "new_5274_07",
  "new_5274_08",
  "new_5274_09",
  "new_5274_10",
  "new_5274_11",
  "new_5274_12",
  "cr864_asisproject",
  "cr864_budgetrecordid",
  "cr864_codecompany",
  "cr864_identifier",
  "cr864_note",
  "cr864_phpc",
  "cr864_unifiedcategory",
  "cr864_category",
  "cr864_sum5274",
  "cr864_sum5271",
  "cr864_sum5211",
  "cr864_sum525",
  "cr864_collectioncategoryinbp",
  "new_submitted",
  "new_sum01",
  "new_sum02",
  "new_sum03",
  "new_sum04",
  "new_sum05",
  "new_sum06",
  "new_sum07",
  "new_sum08",
  "new_sum09",
  "new_sum10",
  "new_sum11",
  "new_sum12",
  "_ownerid_value",
  "_new_costcenter_value",
];

export const getBudgetCopyColumns = (): string[] => [
  ...getBudgetColumns().filter(
    (col) =>
      col !== "cr864_budgetrecordid" &&
      col !== "cr864_sum5271" &&
      col !== "new_submitted" &&
      col !== "_new_costcenter_value"
  ),
  "cr864_budgetrecordcopyid",
  "cr864_sum527",
];

export const getHistoryBudgetColumns = (): string[] => [
  ...getBudgetColumns().filter(
    (col) =>
      !col.startsWith("cr864") &&
      col !== "new_submitted" &&
      col !== "_new_costcenter_value"
  ),
  "new_asisprojekt",
  "new_historybudgetid",
  "new_codecompany",
  "new_identifikator",
  "new_phpc",
  "new_kategoria",
  "new_zjednotenakategoria",
  "new_zbernakategoriavbp",
  "new_sum5274",
  "new_sum5271",
  "new_sum5211",
  "new_sum525",
  "_ownerid_value",
  "new_period",
];

export const getHeadColumns = (): string[] => [
  "new_unifiedcategory",
  "new_01",
  "new_02",
  "new_03",
  "new_04",
  "new_05",
  "new_06",
  "new_07",
  "new_08",
  "new_09",
  "new_10",
  "new_11",
  "new_12",
  "new_submitted",
  "new_codecompany",
  "_ownerid_value",
];

export const getOriginalFteColumns = (): string[] => [
  "new_01",
  "new_02",
  "new_03",
  "new_04",
  "new_05",
  "new_06",
  "new_07",
  "new_08",
  "new_09",
  "new_10",
  "new_11",
  "new_12",
  "new_submitted",
  "new_zjednotenakategoria",
  "new_codecompany",
  "new_originalfteid",
];

export const getHistoryFteColumns = (): string[] => [
  ...getOriginalFteColumns().filter((col) => col !== "new_originalfteid"),
  "new_period",
  "new_historyfteid",
  "_ownerid_value",
];

export const getOwnerColumns = (): string[] => [
  "new_codecompany",
  "new_entityownerid",
  "new_name",
  "_ownerid_value",
  "new_submitted",
];

export const getBaseHeaders = (token: string) => ({
  Authorization: `Bearer ${token}`,
  "OData-MaxVersion": "4.0",
  "OData-Version": "4.0",
  Accept: "application/json",
  "Content-Type": "application/json; charset=utf-8",
});
